module.exports = __webpack_public_path__ + "static/media/home-rays.fbc51f85.svg";